<template>
    <div
        @click="isLotteryUser && clickable && onLotteryContainerClick()"
        class="a-lotteryInfoContainer"
        :class="{ clickable: isLotteryUser && clickable }"
    >
        <slot name="top"></slot>
        <p
            v-if="isLotteryUser"
            class="m-0 p-0 a-lotteryInfoContainer__desc"
            :class="`${customClass} ${fontTiny ? 'tiny' : ''} ${
                fontBig ? 'big' : ''
            }`"
        >
            {{
                multiple
                    ? 'Są to przykładowe elementy '
                    : ' To jest przykładowy element '
            }}
            Panelu Detalisty. Jeśli chcesz korzystać z pełnej funkcjonalności
            aplikacji dołącz do M/platform
        </p>
        <slot name="bottom"></slot>
    </div>
</template>

<script>
export default {
    name: 'LotteryInfoContainer',
    props: {
        fontTiny: {
            type: Boolean,
            default: false
        },
        fontBig: {
            type: Boolean,
            default: false
        },
        customClass: {
            type: String,
            default: ''
        },
        clickable: {
            type: Boolean,
            default: false
        },
        multiple: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        isLotteryUser() {
            return this.$store.getters.isLotteryUser
        }
    },
    methods: {
        onLotteryContainerClick() {
            this.$store.dispatch('onLotteryUserNoPermission')
        }
    }
}
</script>